


































































































































import * as d3 from 'd3';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { tooltip } from '@libs/unified-ui-framework/src/shared/tooltip-dir';
import { SwIconButton } from '@libs/unified-ui-framework/src/shared/sw-icon-button';
import { LocationData, RadarData  } from './types';
import { GeometryObject, GeoJsonProperties, Feature  } from 'geojson';
import { Selection } from 'd3-selection';
@Component({
  directives:{
    tooltip,
  },
  components: {
    SwIconButton,
  },
})
export default class SwGeoMapSvg extends Vue{
  cssPrefix:string = 'sw-geo-map-svg';
  @Prop({
    type: Array,
    default() { return []; },
  })
  locationArray: LocationData[];

  @Prop({
    type: Array,
    default() { return []; },
  })
  radarArray: RadarData[];

  @Prop({
    type:Array,
    default() { return []; },
  })
  countryData: Feature<GeometryObject, GeoJsonProperties>[];

  @Prop({
    default() { return 'light'; },
  })
  theme: string;

  svg: Selection<Element, {}, any, any>;
  container: Selection<Element, {}, any, any>;
  overlay: Selection<Element, {}, any, any>;

  zoomBehaviour = d3.zoom();
  dragBehavior = d3.drag();

  projection = d3.geoEquirectangular()
                 .center([-10, -4]);
  geoPath = d3.geoPath()
              .projection(this.projection);

  arcPathBegin = d3.arc()
                   .startAngle(0)
                   .endAngle(Math.PI * 2)
                   .outerRadius(26)
                   .innerRadius(16);

  arcPathEnd = d3.arc()
                 .startAngle(0)
                 .endAngle(Math.PI * 2)
                 .outerRadius(42)
                 .innerRadius(30);

  coordinateToLocation(coordinate:number[]) {
    const location = this.projection([coordinate[0], coordinate[1]]);
    return location;
  }

  addZoom() {
    const zoomBehaviour = this.zoomBehaviour
                              .on('zoom',  () => {
                                this.svg.attr('transform', `scale(${d3.event.transform.k})`);
                              });
    zoomBehaviour(this.svg);
  }

  zoomIn() {
    this.zoomBehaviour.scaleBy(this.svg, 1.1);
  }

  zoomOut() {
    this.zoomBehaviour.scaleBy(this.svg, 0.9);

  }

  zoomToOriginal() {
    this.zoomBehaviour.scaleTo(this.svg, 1.0);
    this.container.attr('transform', 'translate(0,0)');
  }

  addDrag() {
    let startX: number;
    let startY: number;
    let dx: number;
    let dy: number;
    let transX: number = 0;
    let transY: number = 0;
    let gEle;

    const dragBehavior = this.dragBehavior
                             .on('start', () => {
                               startX = d3.event.x ;
                               startY = d3.event.y ;
                               console.warn(this.container);
                               gEle = this.$el.querySelector('svg g');
                               gEle = this.$el.querySelector('svg g');
                               if (gEle != null) {
                                 const transform = (gEle as any).transform;
                                 if (transform != null && transform.baseVal[0]) {
                                   transX = transform.baseVal[0].matrix.e;
                                   transY = transform.baseVal[0].matrix.f;
                                 }

                               }
                             })
                             .on('drag', () => {
                               dx = d3.event.x - startX;
                               dy = d3.event.y - startY;
                               dx += transX;
                               dy += transY;

                               this.container.attr('transform', `translate(${dx}, ${dy})`);
                             });
    dragBehavior(this.overlay);
    dragBehavior(this.container);
  }

  @Watch('radarArray')
  onRadarArrayChange() {
    let i;
    for (i = 0 ; i < this.radarArray.length ; i += 1) {
      const location = this.coordinateToLocation(this.radarArray[i].coordinate);
      if (location != null) {
        this.radarArray[i].location = location;
        this.radarArray[i].translate = `translate(${location[0]},${location[1]})`;
      }
    }
  }

  @Watch('locationArray')
  onLocationArrayChange() {
    let i;
    for (i = 0 ; i < this.locationArray.length ; i += 1) {
      const location = this.coordinateToLocation(this.locationArray[i].coordinate);
      if (location != null) {
        this.locationArray[i].location = location;
      }
    }
  }

  mounted() {
    let i;
    for (i = 0 ; i < this.locationArray.length ; i += 1) {
      const location = this.coordinateToLocation(this.locationArray[i].coordinate);
      if (location != null) {
        this.locationArray[i].location = location;
      }
    }

    for (i = 0 ; i < this.radarArray.length ; i += 1) {
      const location = this.coordinateToLocation(this.radarArray[i].coordinate);
      if (location != null) {
        this.radarArray[i].location = location;
        this.radarArray[i].translate = `translate(${location[0]},${location[1]})`;
      }
    }

    this.svg = d3.select(this.$el)
                 .select('svg');
    this.container = d3.select(this.$el)
                       .select('g');

    this.overlay = d3.select(this.$el)
                     .select('rect');

    this.addZoom();
    this.addDrag();
  }

}
